// API Endpoints configuration
export const API_ENDPOINTS = {
  // Authentication
  AUTH_GOOGLE: '/auth/google',
  AUTH_LOGOUT: '/auth/logout',

  // User
  USER_ME: '/user/me',
  USER_UPDATE: '/user/update',
  USER_LICENSE: '/user/license',

  // Subscription
  SUBSCRIPTION_ME: '/subscriptions/me',
  SUBSCRIPTION_UPGRADE: '/subscriptions/upgrade',
  SUBSCRIPTION_DOWNGRADE: '/subscriptions/downgrade',
  SUBSCRIPTION_CANCEL: '/subscriptions/cancel',

  // Stats
  STATS: '/stats',
  STATS_PROGRESS: '/stats/progress',
  STATS_INTERACTIONS: '/stats/interactions',
  STATS_DASHBOARD: '/stats/dashboard', // Combined dashboard data

  // Words
  WORDS: '/words',

  // Learning (Webview specific)
  LEARN_TODAY: '/learn/today',
  LEARN_START_SESSION: '/learn/start-session',
  LEARN_MARK_LEARNED: '/learn/mark-learned',
  LEARN_EXPIRE_TOKEN: '/learn/expire-token',
  LEARN_WORD_DETAIL: '/learn/word',
  LEARN_HISTORY: '/learn/history',
  LEARN_COLLECTION: '/learn/collection',

  // Audio
  AUDIO_STREAM: '/audio/stream',

  // Leads
  LEADS: '/leads',
} as const;

export type ApiEndpoint = (typeof API_ENDPOINTS)[keyof typeof API_ENDPOINTS];
